export const colorDangerTransparent = 'hsla(355, 69%, 57%, 0.25)'
export const colorGreyDark = 'hsl(0, 0%, 21%)'
export const colorPrimary = 'hsl(159, 69%, 47%)'
export const colorPrimaryTransparent = 'hsla(159, 69%, 47%, 0.25)'

export function getGraphOptions(
  xMin: number | string,
  xMax: number | string,
  type: 'line' | 'bar' | 'doughnut' = 'line',
  minAcceptable: number = 0,
  maxAcceptable: number = 0
) {
  // TODO: add type
  const range = maxAcceptable - minAcceptable
  const padding = range * 0.1

  let legendConfig = { display: false }
  let xAxisConfig = { ticks: { color: colorGreyDark } }
  let yAxisConfig = { ticks: { color: colorGreyDark } }

  switch (type) {
    case 'line':
      xAxisConfig = {
        ...xAxisConfig,
        max: xMax,
        min: xMin,
        ticks: {
          ...xAxisConfig.ticks,
          maxRotation: 0,
        },
        type: 'linear',
      }
      yAxisConfig = {
        ...yAxisConfig,
        max: maxAcceptable + padding,
        min: minAcceptable - padding,
      }

      break;
    case 'bar':
      xAxisConfig = {
        ...xAxisConfig,
        type: 'category',
      }
      yAxisConfig = {
        ...yAxisConfig,
        beginAtZero: true,
        ticks: {
          ...yAxisConfig.ticks,
          stepSize: 1,
        },
        title: {
          color: colorGreyDark,
          display: true,
          text: 'Frequency',
        },
      }

      break;
    case 'doughnut':
      legendConfig = {
        align: 'start',
        display: true,
        position: window.innerWidth > 600 ? 'right' : 'bottom',
        labels: {
          boxHeight: 20,
          boxWidth: 20,
          font: {
            size: 16
          }
        }
      }
      xAxisConfig = { display: false }
      yAxisConfig = { display: false }

      break;
  }

  return {
    animation: false,
    maintainAspectRatio: false,
    plugins: { legend: legendConfig },
    scales: {
      x: xAxisConfig,
      y: yAxisConfig,
    },
  }
}
